module.exports = __webpack_public_path__ + "static/media/gray-arrow-right.503ebdf0.svg";